// src/api/timesheets.js

import {get, post, patch, postFormData} from "@/lib/fetcher"

/**
 * Fetch a single timesheet from the API by job slug
 */

export async function getCandidateQuestionnaireResponses(){
    return await get ('/candidates/candidate_questionnaire_responses')
}

export async function patchCandidateQuestionnaireResponses(data){
    return await patch ('/candidates', 'candidate_questionnaire_responses', data)
}

// export async function postCandidateCompliance(complianceTypeId, document){
//     return await postFormData('/candidates/candidate_compliances', {compliance_type:complianceTypeId, document:document})
// }
